import "reflect-metadata"; // Reflect.getMetadata error fix
import "../assets/styles/application.scss";

var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
